<template>
  <UiDropdownInput
    class="sort-dropdown"
    :label="{
      text: `${$t('products.sort')}:`,
      position: LabelPosition.LEFT,
    }"
    :dropdown-list="sortOptions"
    @update:selected-option="handleSelectedOption"
  />
</template>

<script setup lang="ts">
import type { SortProps } from '~/types/components/product-listing/sort/sort.types'
import UiDropdownInput, { LabelPosition } from '@sephora-asia/ui-dropdown-input'

const emit = defineEmits<{
  (event: 'update:selectedOption', value: string): void
}>()

defineProps<SortProps>()

const { trackEvent } = useGtmTrack()

function handleSelectedOption(value: string) {
  emit('update:selectedOption', value)
  onTrackingEvent(value)
}

function onTrackingEvent(value: string) {
  trackEvent({
    event: 'click',
    params: {
      event_category: 'Filters',
      event_action: 'Sort By',
      event_label: value,
    },
  })
}
</script>

<style lang="scss" scoped>
.sort-dropdown {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  margin-bottom: 48px;

  :deep(.label-container) {
    @extend .headline-m;
  }
}
</style>
